/* eslint-disable react/no-array-index-key */
import React from "react";
import { Tag } from "carbon-components-react";
import { ChevronSort16, Filter16 } from "@carbon/icons-react";

import { ActionKind, ColumnDisplay, HydratedAction } from "../shared";
import { columnIsVisible } from "../helpers";

const styles = require("./styles.module.scss");

interface ActionsListProps {
  actions: HydratedAction[];
  columnDisplay: ColumnDisplay[];
  removeActionAtIndex: Function;
  openUpdateModalForActionAtIndex: Function;
}

const ActionsList: React.FC<ActionsListProps> = ({
  actions,
  columnDisplay,
  openUpdateModalForActionAtIndex,
  removeActionAtIndex,
}) => {
  if (!actions.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      {actions.map((a: HydratedAction, idx) => (
        <Tag
          key={`${idx}-${a.displayText}`}
          onClick={() => {
            if (!columnIsVisible(columnDisplay, a.jsonKey)) {
              return;
            }
            openUpdateModalForActionAtIndex(idx);
          }}
          onClose={() => removeActionAtIndex(idx)}
          disabled={!columnIsVisible(columnDisplay, a.jsonKey)}
          type={a.kind === ActionKind.Filter ? "cyan" : "purple"}
          filter
        >
          <div style={{ display: "flex" }}>
            {a.kind === ActionKind.Filter ? <Filter16 /> : <ChevronSort16 />}
            &nbsp;
            <span>{a.displayText}</span>
          </div>
        </Tag>
      ))}
    </div>
  );
};

export default ActionsList;
